/* global $ */
import throttle from 'lodash.throttle';

class NavReveal {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.$header = $('.site-header');
    this.$announcement = $('.announcement');

    this.lastScroll = 0;
    this.scrollTop = 0;
    this.announcementHeight = 0;
    this.documentHeight = 0;
    this.headerHeight = 0;
    this.windowHeight = $(window).height();
    this.direction = '';

    this.init();
  }

  init() {
    this.$body.addClass('nav--is-in-view');
    this.$window.on('scroll.nav', throttle(this.onScroll, 20).bind(this));

    this.documentHeight = $(document).height();
    this.windowHeight = $(window).height();
    this.headerHeight = this.$header.outerHeight() * 2;
    this.announcementHeight = this.$announcement.length ? this.$announcement.outerHeight() * 2 : 0;
  }

  onScroll() {
    this.scrollTop = $(window).scrollTop();

    this.getScrollDirection();
    this.toggleNav();
  }

  getScrollDirection() {
    const currentScroll = window.pageYOffset;

    if (currentScroll > this.lastScroll && currentScroll >= 1) {
      this.direction = 'down';
    } else if (currentScroll < this.lastScroll) {
      this.direction = 'up';
    }

    this.lastScroll = currentScroll;
    return this.direction;
  }

  toggleNav() {
    if (this.direction === 'down') {
      if (this.scrollTop > this.headerHeight - this.announcementHeight) {
        this.$body.removeClass('nav--is-in-view');
      }
    }

    if (this.direction === 'up') {
      if (this.scrollTop > this.headerHeight - this.announcementHeight) {
        this.$body.addClass('nav--is-in-view');
        this.$header.css('top', 0);
      }
      if (this.scrollTop < this.announcementHeight) {
        this.$header.css('top', this.announcementHeight / 2);
      }
    }
  }

  deinit() {
    this.$window.off('scroll.nav');
  }
}

export default NavReveal;
